import * as React from 'react';
import { InterviewRuralResult } from './interview-rural-result';
import { InterviewStatus } from './interview-status';

export const SituationRural = ({ props }) => {
  if (props.statusInterview === 'AGUARDANDO_AVALIACAO') {
    return <InterviewRuralResult props={props} />;
  } else if (props.statusCompletingInterview === 'CERTIFICADA') {
    return <InterviewStatus props={props} />;
  } else if (props.statusCompletingInterview === 'DESISTENTE') {
    return <InterviewStatus props={props} />;
  } else {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <InterviewStatus props={props} />
        <InterviewRuralResult props={props} />
      </div>
    );
  }
};
